import { Link } from "react-router-dom";
import { useBilingual } from "@/lib/bilingual";
import { asset } from "@/lib/asset";

const FactoryCTA = () => {
  const b = useBilingual();
  return (
    <section className="relative py-28 overflow-hidden bg-stone-900">
      <div className="absolute inset-0 opacity-8">
        <img
          src={asset("/editorial/factory-cta-bg.jpg")}
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-stone-900/90 via-stone-900/80 to-stone-900/95" />
      <div className="absolute top-0 left-0 right-0 h-px bg-amber-700/40" />

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center gap-4 mb-8">
          <span className="block h-px w-12 bg-amber-700/50" />
          <span className="text-amber-500 text-xs font-semibold tracking-widest uppercase">
            {b("Visit Forwaro", "來訪 Forwaro")}
          </span>
          <span className="block h-px w-12 bg-amber-700/50" />
        </div>

        <h2
          className="text-3xl md:text-6xl font-bold text-white mb-5 leading-tight"
          style={{ fontFamily: "var(--font-display)" }}
        >
          {b("See the Dongguan factory in person.", "歡迎親臨東莞廠區參觀")}
        </h2>
        <p className="text-stone-400 text-base md:text-lg max-w-xl mx-auto mb-12 leading-relaxed">
          {b(
            "Schedule a factory visit to walk the production floor, or request a sample kit to evaluate materials and finishes in your own space.",
            "可預約參觀產線，或索取樣品包在自己的空間實際評估材質與表面處理。",
          )}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact?intent=visit"
            className="bg-amber-700 hover:bg-amber-600 text-white font-semibold px-10 py-4 rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            {b("Schedule a Factory Visit", "預約參訪工廠")}
          </Link>
          <Link
            to="/contact?intent=sample"
            className="border border-stone-600 hover:border-stone-400 text-stone-300 hover:text-white font-semibold px-10 py-4 rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            {b("Request a Sample", "索取樣品")}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FactoryCTA;
